export default function Footer() {
  return (
    <footer className="bg-[#1A2B4A] text-white py-16 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Left Column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/e69c6ee7-e44d-4418-9324-20668ca46385.png" 
                alt="ANA修行サポート" 
                className="h-8 w-auto"
              />
              <h3 className="text-xl font-bold">ANA修行サポート</h3>
            </div>
            <p className="text-sm text-[#B0BEC5] leading-relaxed">
              合理的設計による、再現可能なANAステータス修行サポート。最適ルート設計で、あなたの目標達成をサポートします。
            </p>
          </div>

          {/* Middle Column */}
          <div>
            <h4 className="text-sm font-semibold mb-4">サービス</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-sm text-[#90CAF9] hover:text-white transition-colors cursor-pointer">SFC修行サポート</a></li>
              <li><a href="#" className="text-sm text-[#90CAF9] hover:text-white transition-colors cursor-pointer">ダイヤモンドサポート</a></li>
              <li><a href="#consultation" className="text-sm text-[#90CAF9] hover:text-white transition-colors cursor-pointer">無料相談</a></li>
            </ul>
          </div>

          {/* Right Column */}
          <div>
            <h4 className="text-sm font-semibold mb-4">お問い合わせ</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-sm text-[#90CAF9] hover:text-white transition-colors cursor-pointer">よくある質問</a></li>
              <li><a href="#consultation" className="text-sm text-[#90CAF9] hover:text-white transition-colors cursor-pointer">お問い合わせフォーム</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 border-t border-[#78909C] flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-[13px] text-[#78909C]">
            © 2025 ANA Status Run Support. All rights reserved.
          </p>

          <div className="flex gap-4">
            <a href="#" className="w-10 h-10 flex items-center justify-center border border-[#78909C] rounded-full hover:border-[#90CAF9] transition-colors cursor-pointer">
              <i className="ri-twitter-x-line text-[#90CAF9]"></i>
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center border border-[#78909C] rounded-full hover:border-[#90CAF9] transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-[#90CAF9]"></i>
            </a>
            <a href="#" className="w-10 h-10 flex items-center justify-center border border-[#78909C] rounded-full hover:border-[#90CAF9] transition-colors cursor-pointer">
              <i className="ri-instagram-line text-[#90CAF9]"></i>
            </a>
          </div>

          <div className="flex items-center gap-3 text-[13px]">
            <a href="#" className="text-[#90CAF9] hover:text-white transition-colors cursor-pointer">プライバシーポリシー</a>
            <span className="text-[#78909C]">|</span>
            <a href="#" className="text-[#90CAF9] hover:text-white transition-colors cursor-pointer">特定商取引法</a>
            <span className="text-[#78909C]">|</span>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-[#90CAF9] hover:text-white transition-colors cursor-pointer">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
